import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  mobileDrawerVisible: false,
  onboardingJourneyVisible: false,
  requestCsvButtonDisabled: false,
  isWelcomeClosed: false,
  isFirstVisit: true,
};

export const removeLogInFlag = () => {
  sessionStorage.removeItem('isLoggedIn');
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setMobileDrawerVisible: (state, action: PayloadAction<boolean>) => {
      state.mobileDrawerVisible = action.payload;
    },
    setOnboardingJourneyVisible: (state, action: PayloadAction<boolean>) => {
      state.onboardingJourneyVisible = action.payload;
    },
    setRequestCsvButtonDisabled: (state, action: PayloadAction<boolean>) => {
      state.requestCsvButtonDisabled = action.payload;
    },
    setWelcomeClosed: (state, action: PayloadAction<boolean>) => {
      state.isWelcomeClosed = action.payload;
    },
    setFirstVisit: (state, action: PayloadAction<boolean>) => {
      state.isFirstVisit = action.payload;
    },
  },
});

export const {
  setMobileDrawerVisible,
  setOnboardingJourneyVisible,
  setRequestCsvButtonDisabled,
  setWelcomeClosed,
  setFirstVisit,
} = appSlice.actions;

export default appSlice.reducer;
